module.exports = __webpack_public_path__ + "img/phoneLogoDetailCampus.d752ee4.png";